export function initBreadcrumbColor() {
	const main = document.getElementById('main');
	const section = main.querySelector('.mb-content-area');
	const breadcrumb = document.getElementById('breadcrumb');

	console.log(main, section, breadcrumb);


	if (!section || !breadcrumb) {
		return;
	}

	const hasDarkBackground = section.classList.contains('content-bg-secondary') || section.classList.contains('content-bg-tertiary');

	if (!hasDarkBackground) {
		return;
	}

	breadcrumb.classList.add('text-white');

	breadcrumb.querySelectorAll('.delimiter').forEach((delimiter) => {
		delimiter.classList.add('delimiter-light');
	});
}
